<app-root *ngIf="configReady$ | async"></app-root>
